export enum UserRole {
  Owner = "Owner",
  Admin = "Admin",
  ReadOnly = "ReadOnly",
}
